import { capabilities, setModifierManager } from '@ember/modifier';

import type { ModifierLike } from '@glint/template';

interface State {
	element?: HTMLElement;
}

interface Args {
	positional: unknown[];
	named: Record<string, unknown>;
}

type OnChangeFn = (element: HTMLElement) => void;

// Copied functionality from @ember/render-modifiers
// See more at https://github.com/ember-template-lint/ember-template-lint/blob/master/docs/rule/no-at-ember-render-modifiers.md

const WillDestroyModifier = setModifierManager(
	() => ({
		capabilities: capabilities('3.22', { disableAutoTracking: true }),
		createModifier() {
			return { element: null };
		},

		installModifier(state: State, element: HTMLElement) {
			state.element = element;
		},

		updateModifier() {
			// nothing
		},

		destroyModifier(state: State, args: Args) {
			const fn = args.positional[0] as OnChangeFn;

			fn(state.element!);
		},
	}),
	class WillDestroyModifierClass {},
);

type Modifier = ModifierLike<{
	Args: { Positional: [handler: (node: HTMLElement) => void] };
	Return: void;
}>;

export default WillDestroyModifier as unknown as Modifier;
